<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
>

</script>
<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Edit City"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Name</label>
                      <validation-provider
                          #default="{ errors }"
                          name="title"
                          rules="required"
                      >
                        <b-form-input
                            id="Name"
                            v-model="updatedCountry.name"
                            name="name"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="name_ar">Name «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="name_ar"
                          rules="required"
                      >
                        <b-form-input
                            id="Name_ar"
                            v-model="updatedCountry.name_ar"
                            name="name_ar"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import {codeMultiple, codeBasic} from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import countriesService from '@/services/countriesService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Spinner from '@/shared/loader/Spinner'

export default {
  components: {
    BCardCode,
    Spinner,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['item'],
  data() {
    return {
      updatedCountry: {
        id: '',
        name: '',
        name_ar: '',
      },
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      codeBasic,
      selected: '',
    }
  },
  mounted() {
    this.$watch(() => this.item, val => {
      this.updatedCountry= {
        id: val.id,
        name: val.name,
        name_ar: val.name_ar
      }

      this.selected = val.title ?? null
    })
  },
  methods: {

    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              countriesService.put(this.updatedCountry.id, this.updatedCountry)
                  .then(response => {
                    if (response && response.status === 200) {
                      this.$emit('refresh', 'true')
                      this.updatedCountry = {
                        name: '',
                        name_ar: '',
                      }

                      $('#editModal').modal('hide')

                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Country Is Updated Successfully !`,
                        },
                      })
                    }

                  })
            }
          })
    },
    resetDropzone() {
      this.$refs.createRef.removeAllFiles()

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
